import React, { Suspense, lazy } from 'react';
import {BrowserRouter as Router, Switch, Route, Redirect} from 'react-router-dom';
import ProtfolioFull from "./pages/ProtfolioFull";
import PageScrollTop from './components/pageToTop/PageScrollTop'
import LoadingFallback from './components/LoadingFallback';
import { SiteSettingsProvider } from './context/SiteSettingsContext';
import './assets/scss/style.scss';
import 'bootstrap/dist/js/bootstrap.bundle.min';

// Keep Home page eager (LCP page)
import Home from "./pages/Home";

// Lazy load all other pages
const Splash = lazy(() => import("./pages/Splash"));
const HomeDefault = lazy(() => import("./pages/HomeDefault"));
const BusinessConsulting2 = lazy(() => import("./pages/BusinessConsulting2"));
const Corporate = lazy(() => import("./pages/Corporate"));
const Business = lazy(() => import("./pages/Business"));
const DigitalAgency = lazy(() => import("./pages/DigitalAgency"));
const Finance = lazy(() => import("./pages/Finance"));
const Company = lazy(() => import("./pages/Company"));
const Marketing = lazy(() => import("./pages/Marketing"));
const TravelAgency = lazy(() => import("./pages/TravelAgency"));
const Consulting = lazy(() => import("./pages/Consulting"));
const SeoAgency = lazy(() => import("./pages/SeoAgency"));
const PersonalPortfolio = lazy(() => import("./pages/PersonalPortfolio"));
const EventConference = lazy(() => import("./pages/EventConference"));
const CreativePortfolio = lazy(() => import("./pages/CreativePortfolio"));
const Freelancer = lazy(() => import("./pages/Freelancer"));
const InternationalConsulting = lazy(() => import("./pages/InternationalConsulting"));
const Startup = lazy(() => import("./pages/Startup"));
const WebAgency = lazy(() => import("./pages/WebAgency"));
const CategoryList = lazy(() => import("./pages/CategoryList"));
const TagList = lazy(() => import("./pages/TagList"));
const Author = lazy(() => import("./pages/Author"));
const AboutUs = lazy(() => import("./pages/AboutUs"));
const About = lazy(() => import("./pages/About"));
const PortfolioDetails = lazy(() => import("./pages/PortfolioDetails"));
const BlogDetails = lazy(() => import("./pages/BlogDetails"));
const Error = lazy(() => import("./pages/Error"));
const ServicePage = lazy(() => import("./pages/ServicePage"));
const Blog = lazy(() => import("./pages/Blog"));
const ServicDetails = lazy(() => import('./pages/ServicDetails'));
const Products = lazy(() => import("./pages/Products"));
const ProductDetails = lazy(() => import("./pages/ProductDetails"));
const LocalSeoLanding = lazy(() => import("./pages/LocalSeoLanding"));

// Lazy load element pages (less critical)
const Elements = lazy(() => import("./elements/elements/Elements"));
const Button = lazy(() => import("./elements/button/Button"));
const Service = lazy(() => import("./elements/service/Service"));
const CounterUp = lazy(() => import("./elements/counterup/CounterUp"));
const Progressbar = lazy(() => import("./elements/progressbar/Progressbar"));
const Portfolio = lazy(() => import("./elements/portfolio/Portfolio"));
const portfolioThreeColumn = lazy(() => import("./elements/portfolio/PortfolioThreeColumn"));
const PortfolioFullWidth = lazy(() => import("./elements/portfolio/PortfolioFullWidth"));
const PortfolioGrid = lazy(() => import("./elements/portfolio/PortfolioGrid"));
const PortfolioBoxLayout = lazy(() => import("./elements/portfolio/PortfolioBoxLayout"));
const Social = lazy(() => import("./elements/social/Social"));
const Team = lazy(() => import("./elements/team/Team"));
const Timeline = lazy(() => import("./elements/timeline/Timeline"));
const Testimonial = lazy(() => import("./elements/testimonial/Testimonial"));
const RnAccordion = lazy(() => import("./elements/accordion/RnAccordion"));
const Tab = lazy(() => import("./elements/tab/Tab"));
const Pricing = lazy(() => import("./elements/pricing/Pricing"));
const Split = lazy(() => import("./elements/split/Split"));
const CalltoAction = lazy(() => import("./elements/calltoaction/CalltoAction"));
const Video = lazy(() => import("./elements/video/Video"));
const Gallery = lazy(() => import("./elements/gallery/Gallery"));
const Contact = lazy(() => import("./elements/contact/Contact"));
const Brand = lazy(() => import("./elements/brand/Brand"));
const AdvanceTab = lazy(() => import("./elements/advancetab/AdvanceTab"));
const AdvancePricing = lazy(() => import("./elements/advancePricing/AdvancePricing"));
const BlogGridView = lazy(() => import("./components/blog/BlogGridView"));
const BlogListView = lazy(() => import("./components/blog/BlogListView"));
const BlogGridSidebar = lazy(() => import("./components/blog/BlogGridSidebar"));
const BlogListSidebar = lazy(() => import("./components/blog/BlogListSidebar"));
const TestimonialOne = lazy(() => import('./elements/testimonial/TestimonialOne'));
const TimelineTwo = lazy(() => import('./elements/timeline/TimelineTwo'));
const TeamFour = lazy(() => import('./elements/team/TeamFour'));
const Testimonals = lazy(() => import('./elements/testimonial/Testimonals'));
const Timelines = lazy(() => import('./elements/timeline/Timelines'));
const Teams = lazy(() => import('./elements/team/Teams'));


const App = () => {
    return (
        <SiteSettingsProvider>
        <Router>
            <PageScrollTop>
                <Suspense fallback={<LoadingFallback />}>
                <Switch>
                    <Route path={`${process.env.PUBLIC_URL + "/splash"}`} exact component={Splash}/>
                    <Route path={`${process.env.PUBLIC_URL + "/business-consulting"}`} exact component={HomeDefault}/>
                    <Route path={`${process.env.PUBLIC_URL + "/business-consulting-2"}`} exact component={BusinessConsulting2}/>
                    <Route path={`${process.env.PUBLIC_URL + "/corporate"}`} exact component={Corporate}/>
                    <Route path={`${process.env.PUBLIC_URL + "/business"}`} exact component={Business}/>
                    <Route path={`${process.env.PUBLIC_URL + "/digital-agency"}`} exact component={DigitalAgency}/>
                    <Route path={`${process.env.PUBLIC_URL + "/finance"}`} exact component={Finance}/>
                    <Route path={`${process.env.PUBLIC_URL + "/company"}`} exact component={Company}/>
                    <Route path={`${process.env.PUBLIC_URL + "/marketing"}`} exact component={Marketing}/>
                    <Route path={`${process.env.PUBLIC_URL + "/travel-agency"}`} exact component={TravelAgency}/>
                    <Route path={`${process.env.PUBLIC_URL + "/consulting"}`} exact component={Consulting}/>
                    <Route path={`${process.env.PUBLIC_URL + "/seo-agency"}`} exact component={SeoAgency}/>
                    <Route path={`${process.env.PUBLIC_URL + "/personal-portfolio"}`} exact component={PersonalPortfolio}/>
                    <Route path={`${process.env.PUBLIC_URL + "/event-conference"}`} exact component={EventConference}/>
                    <Route path={`${process.env.PUBLIC_URL + "/creative-portfolio"}`} exact component={CreativePortfolio}/>
                    <Route path={`${process.env.PUBLIC_URL + "/freelancer"}`} exact component={Freelancer}/>
                    <Route path={`${process.env.PUBLIC_URL + "/international-consulting"}`} exact component={InternationalConsulting}/>
                    <Route path={`${process.env.PUBLIC_URL + "/startup"}`} exact component={Startup}/>
                    <Route path={`${process.env.PUBLIC_URL + "/web-agency"}`} exact component={WebAgency}/>

                    {/* Blog Part  */}
                    <Route path={`${process.env.PUBLIC_URL + "/blog-grid"}`} exact component={BlogGridView}/>
                    <Route path={`${process.env.PUBLIC_URL + "/blog-list-view"}`} exact component={BlogListView}/>
                    <Route path={`${process.env.PUBLIC_URL + "/blog-grid-sidebar"}`} exact component={BlogGridSidebar}/>
                    <Route path={`${process.env.PUBLIC_URL + "/blog-list-sidebar"}`} exact component={BlogListSidebar}/>
                    <Route path={`${process.env.PUBLIC_URL + "/category/:slug"}`} exact component={CategoryList}/>
                    <Route path={`${process.env.PUBLIC_URL + "/archive/:slug"}`} exact component={Author}/>
                    <Route path={`${process.env.PUBLIC_URL + "/tag/:slug"}`} exact component={TagList}/>

                    <Route path={`${process.env.PUBLIC_URL + "/elements"}`} exact component={Elements}/>
                    <Route path={`${process.env.PUBLIC_URL + "/button"}`} exact component={Button}/>
                    <Route path={`${process.env.PUBLIC_URL + "/service"}`} exact component={Service}/>
                    <Route path={`${process.env.PUBLIC_URL + "/counter"}`} exact component={CounterUp}/>
                    <Route path={`${process.env.PUBLIC_URL + "/progressbar"}`} exact component={Progressbar}/>
                    <Route path={`${process.env.PUBLIC_URL + "/social-share"}`} exact component={Social}/>
                    <Route path={`${process.env.PUBLIC_URL + "/team"}`} exact component={Team}/>
                    <Route path={`${process.env.PUBLIC_URL + "/testimonial"}`} exact component={Testimonial}/>
                    <Route path={`${process.env.PUBLIC_URL + "/timeline"}`} exact component={Timeline}/>
                    <Route path={`${process.env.PUBLIC_URL + "/accordion"}`} exact component={RnAccordion}/>
                    <Route path={`${process.env.PUBLIC_URL + "/tab"}`} exact component={Tab}/>
                    <Route path={`${process.env.PUBLIC_URL + "/pricing"}`} exact component={Pricing}/>
                    <Route path={`${process.env.PUBLIC_URL + "/split"}`} exact component={Split}/>
                    <Route path={`${process.env.PUBLIC_URL + "/call-to-action"}`} exact component={CalltoAction}/>
                    <Route path={`${process.env.PUBLIC_URL + "/video-popup"}`} exact component={Video}/>
                    <Route path={`${process.env.PUBLIC_URL + "/gallery"}`} exact component={Gallery}/>
                    <Route path={`${process.env.PUBLIC_URL + "/contact"}`} exact component={Contact}/>
                    <Route path={`${process.env.PUBLIC_URL + "/brand"}`} exact component={Brand}/>
                    <Route path={`${process.env.PUBLIC_URL + "/advance-tab"}`} exact component={AdvanceTab}/>
                    <Route path={`${process.env.PUBLIC_URL + "/advance-pricing"}`} exact component={AdvancePricing}/>
                    <Route path={`${process.env.PUBLIC_URL + "/aboutus"}`} exact component={AboutUs}/>

                    <Route path={`${process.env.PUBLIC_URL + "/error"}`} exact component={Error}/>
                    
                    <Route path={`${process.env.PUBLIC_URL + "/portfolios"}`} exact component={Portfolio}/>
                    <Route path={`${process.env.PUBLIC_URL + "/portfolio-three-column"}`} exact component={portfolioThreeColumn}/>
                    <Route path={`${process.env.PUBLIC_URL + "/portfolio-full-width"}`} exact component={PortfolioFullWidth}/>
                    <Route path={`${process.env.PUBLIC_URL + "/portfolio-grid-layout"}`} exact component={PortfolioGrid}/>
                    <Route path={`${process.env.PUBLIC_URL + "/portfolio-box-layout"}`} exact component={PortfolioBoxLayout}/>
                    <Route path={`${process.env.PUBLIC_URL + "/portfolio-details/:slug"}`} exact component={PortfolioDetails}/>

                    <Route path={`${process.env.PUBLIC_URL + "/about-us"}`} exact component={About}/>
                    <Route path={`${process.env.PUBLIC_URL + "/portfolio"}`} exact component={ProtfolioFull}/>
                    <Route path={`${process.env.PUBLIC_URL + "/Portfolio"}`} exact><Redirect to="/portfolio" /></Route>
                    <Route path={`${process.env.PUBLIC_URL + "/products"}`} exact component={Products}/>
                    <Route path={`${process.env.PUBLIC_URL + "/products/:slug"}`} exact component={ProductDetails}/>
                    <Route path={`${process.env.PUBLIC_URL + "/Testimonial-One"}`} exact component={TestimonialOne}/>
                    <Route path={`${process.env.PUBLIC_URL + "/Timeline-two"}`} exact component={TimelineTwo}/>
                    <Route path={`${process.env.PUBLIC_URL + "/TeamFour"}`} exact component={TeamFour}/>
                    <Route path={`${process.env.PUBLIC_URL + "/Testimonials"}`} exact component={Testimonals}/>
                    <Route path={`${process.env.PUBLIC_URL + "/Timelines"}`} exact component={Timelines}/>
                    <Route path={`${process.env.PUBLIC_URL + "/Teams"}`} exact component={Teams}/>
                    

                    
                    <Route path={`${process.env.PUBLIC_URL + "/"}`} exact component={Home}/>
                    <Route path={`${process.env.PUBLIC_URL + "/software-company-tirunelveli"}`} exact render={() => <LocalSeoLanding pageSlug="software-company-tirunelveli" />} />
                    <Route path={`${process.env.PUBLIC_URL + "/custom-software-development-tirunelveli"}`} exact render={() => <LocalSeoLanding pageSlug="custom-software-development-tirunelveli" />} />
                    <Route path={`${process.env.PUBLIC_URL + "/mobile-app-development-tirunelveli"}`} exact render={() => <LocalSeoLanding pageSlug="mobile-app-development-tirunelveli" />} />
                    <Route path={`${process.env.PUBLIC_URL + "/our-services"}`} exact component={ServicePage}/>
                    <Route path={`${process.env.PUBLIC_URL + "/blog"}`} exact component={Blog}/>
                    <Route path={`${process.env.PUBLIC_URL + "/services/:subtitle"}`} exact component={ServicDetails}/>

                    {/* New blog details route at root-level: /:slug */}
                    <Route path={`${process.env.PUBLIC_URL + "/:slug"}`} exact component={BlogDetails}/>

                </Switch>
                </Suspense>
            </PageScrollTop>
        </Router>
        </SiteSettingsProvider>
    )
}


export default App
